<template>
  <el-dialog :close-on-click-modal="true" :visible="visible" @close="cancel" append-to-body center="" title="知识库类别管理" width="60rem" top="4vh">
    <el-main style="padding: 0px; height: 30rem">
      <div class="patientBox">
        <el-row type="flex" align="middle">
          <el-input size="small" class="condition-wide left-pad" type="text" clearable placeholder="名称" v-model="condition.name" @keyup.enter.native="search" @clear="search">
            <el-button size="small" slot="append" @click="search" :disabled="meta.loading" icon="el-icon-search" ></el-button>
          </el-input>
          <el-button style="margin-left: 3rem" type="primary" size="mini" @click=" info = {}; title = '新增知识库类别'; meta.showHistory = true;">新增</el-button>
        </el-row>
        <el-row>
          <el-table :data="tableData" style="width: 100%" border>
            <el-table-column label="操作" align="center">
              <template slot-scope="{ row }"> 
                <el-button title="取消" type="primary" plain size="mini" circle icon="el-icon-delete" @click="inEdtior(row,true)" ></el-button>
                <!-- <el-button title="打印" type="primary" plain size="mini" circle icon="el-icon-printer" @click="inEdtior(row,true)" ></el-button> -->
              </template>
            </el-table-column>
            <el-table-column label="开始时间" prop="1"></el-table-column>
            <el-table-column label="结束时间" prop="2"></el-table-column>
            <el-table-column label="结算总额" prop="3"></el-table-column>
            <el-table-column label="收款合计" prop="4"></el-table-column>
            <el-table-column label="退款合计" prop="5"></el-table-column>
            <el-table-column label="结账时间" prop="5"></el-table-column>
          </el-table>
        </el-row>

        <pagination style="text-align: center" :entities="entities" :condition="condition" @queryEntities="getinfo" />

        <el-row style="margin-top: 20px; text-align: center">
            <el-button  type="info" size="large" @click.native="$emit('update:visible', false)">关闭</el-button>
        </el-row>
      </div>
    </el-main>
    
    <!-- <shistory v-if="meta.showHistory" :title="title" :visible.sync="meta.showHistory"></shistory> -->
  </el-dialog>
</template>

<script>
import api from "./api";
import { mapGetters } from "sw-hic";
export default {
  components: {
    // shistory: () => import("./shistory"),
    pagination: () => import("@/components/_com/pagination"),
  },
  props: {
    visible: Boolean,
  },
  data() {
    return {
      title: "",
      meta: {
        loading: false,
        showHistory: false,
      },
      tableData: [{
        1:'202204171234',
        2:'西药',
        3:'消化内科',
        4:'张医生',
        5:'203.5',
        child:[{
          1:'抗感染类',
          2:'头孢克肟片 ',
          3:'50mg*18s/盒  ',
          4:'1.5 ',
          5:'1.5 ',
          6:' 35.25',
          7:' 35.25'
        }]
      },{
        1:'202204171234',
        2:'西药',
        3:'消化内科',
        4:'张医生',
        5:'203.5',
        child:[{
          1:'抗感染类',
          2:'头孢克肟片 ',
          3:'50mg*18s/盒  ',
          4:'1.5 ',
          5:'1.5 ',
          6:' 35.25',
          7:' 35.25'
        }]
      }],
      value: "",
      keyword: "",
      info: {},
      entities: {},
      condition: {
        // sort: "sizeDate",
        // asc: false,
        name: "",
        pageIndex: 0,
        pageSize: 10,
      },
    };
  },
  computed: {
    ...mapGetters(["dict", "Enum", "dictEnum"])
  },
  mounted() {
    // this.getinfo();
  },
  created() {},
  methods: {
    filterChange(obj) {
      let key = Object.keys(obj)[0];
      let value = obj[key][0];
      this.condition[key] = value;
      this.search();
    },
    sortChange(obj) {
      // let orderArr = this.condition.orders || [];
      // let type = obj.column.property;

      // let _index = orderArr.findIndex((item) => {
      //   return item.orderCode == type;
      // });
      // if (_index > -1) {
      //   orderArr.splice(_index, 1);
      // }

      // if (obj.column.order) {
      //   let val = obj.column.order.indexOf("asc") > -1 ? "asc" : "desc";
      //   orderArr.unshift({ orderCode: type, orderValue: val });
      // }

      // this.condition.orders = orderArr;
      this.condition.sort = obj.column.property;
      this.condition.asc = obj.column.order.indexOf("asc") > -1 ? true : false;
      this.search();
    },
    search() {
      this.getinfo();
    },
    cancel() {
      this.$emit("close");
      this.$emit("update:visible", false);
    },
    delKnowType(info) {
      this.$confirm("确定要删除此知识库类别！", "删除知识库类别", {
        type: "warning",
      })
        .then(() => {
          this.meta.loading = true;
          api
            .delKnowType(info.id)
            .then((res) => {
              this.meta.loading = false;
              this.$message.success("删除成功");
              this.getinfo();
            })
            .catch((err) => {
              this.meta.loading = false;

              this.$message.error(err);
            });
        })
        .catch((e) => {});
    },
    editKnowType(info) {
      this.info = info;
      this.title = "编辑知识库类别";
      this.meta.showHistory = true;
    },
    async getinfo() {
      this.meta.loading = true;
      await api
        .getKnowType(this.condition)
        .then((res) => {
          this.entities = res;
          this.meta.loading = false;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.meta.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.patientBox {
  height: 5rem;
  margin-bottom: 2rem;
}

.el-row {
  margin-bottom: 10px;
}

.el-row:last-child {
  margin-bottom: 0px;
}

.ztitle {
  margin-top: 10px;
  color: #66b1ff;
}
.inputnw .el-input {
  width: 4rem !important;
}
.headtitle {
  background-color: red !important;
}
.tofvoer{
  text-overflow:ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>
